export const ODF_LOGO_ALT_TEXT = 'Overdosefare logo';
export const HDIR_LOGO_ALT_TEXT = 'Helsedirektoratet logo';
